<template>
  <div class="container">
    <div class="master_one animated zoomIn">
      <img src="@assets/images/master_1.jpg" alt />
    </div>
    <div class="master_two">
      <img src="@assets/images/master_2.jpg" alt />
      <div class="circle animated bounceInUp">
        <img src="@assets/images/master_4.png" alt />
      </div>
    </div>
    <div class="master_three">
      <img src="@assets/images/master_4.jpg" alt />
    </div>
    <div class="master_four">
      <img src="@assets/images/master_5.jpg" alt />
    </div>
    <!--展示区第五块-->
    <div class="master_five">
      <img src="@assets/images/master_6.jpg" alt />
    </div>
    <!--展示区第六块-->
    <div class="master_six">
      <img src="@assets/images/master_7.jpg" alt />
    </div>
    <!--展示区第七块-->
    <div class="master_seven">
      <img src="@assets/images/master_8.jpg" alt />
    </div>
    <div class="master_8">
      <img src="@assets/images/master_9.jpg" alt />
    </div>
    <div class="master_9">
      <img src="@assets/images/master_10.jpg" alt />
    </div>
    <div class="master_10">
      <img src="@assets/images/master_11.jpg" alt />
    </div>
    <div class="master_11">
      <img src="@assets/images/master_12.jpg" alt />
    </div>
    <div class="master_12">
      <img src="@assets/images/master_13.jpg" alt />
    </div>
    <div class="master_13">
      <img src="@assets/images/master_14.jpg" alt />
    </div>
    <div class="master_14">
      <img src="@assets/images/master_15.jpg" alt />
    </div>
    <div class="master_15">
      <img src="@assets/images/master_16.jpg" alt />
    </div>
    <div class="master_16">
      <img src="@assets/images/master_17.jpg" alt />
    </div>
    <div class="master_17">
      <img src="@assets/images/master_18.jpg" alt />
    </div>
    <div class="master_18">
      <img src="@assets/images/master_19.jpg" alt />
    </div>
  </div>
</template>
<script>
export default {
  name: "Guizu"
};
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 640px;
  min-width: 300px;
  margin: 0 auto;
}
.container a {
  display: block;
  font-size: 0;
}
.container div img {
  width: 100%;
  height: 100%;
  display: block;
}
.master_two {
  position: relative;
}
.circle {
  position: absolute;
  left: 50%;
  top: -44.5px;
  margin-left: -44px;
  width: 88px;
  height: 89px;
}
.circle img {
  width: 100%;
  height: 100%;
}

@-webkit-keyframes bounce-up {
  25% {
    -webkit-transform: translateY(10px);
  }
  50%,
  100% {
    -webkit-transform: translateY(0);
  }
  75% {
    -webkit-transform: translateY(-10px);
  }
}

@keyframes bounce-up {
  25% {
    transform: translateY(10px);
  }
  50%,
  100% {
    transform: translateY(0);
  }
  75% {
    transform: translateY(-10px);
  }
}
.circle {
  -webkit-animation: bounce-up 2s linear infinite;
  animation: bounce-up 2s linear infinite;
}
</style>